module.exports = __webpack_public_path__ + "static/mr-press-26-dcd2d62610b6ad913901f7b341a88046.jpg";